import React, { useState } from 'react';
import { CommentsDrawer } from './CommentsDrawer';
import { ConditionSection } from './ConditionSection';
import type { SectionTone } from './ConditionSection';
import { ConditionsHeader } from './ConditionsHeader';
import { ConditionsTableHeader } from './ConditionsTableHeader';
import { LinkDocumentsDialog } from './LinkDocumentsDialog';
import { SendConditionsDialog } from './SendConditionsDialog';
import { useConditions } from '../../hooks/useConditions';
import type { ConditionCategory, SortKey, SortState } from '../../types/conditions';
const groupTones: Record<ConditionCategory, SectionTone> = {
  processor: 1,
  admin: 2,
  title: 3
};
export function ConditionsPanel() {
  const state = useConditions();
  const [sort, setSort] = useState<SortState | null>(null);
  const [sendOpen, setSendOpen] = useState(false);

  /** Click cycles: ascending → descending → original order. */
  function cycleSort(key: SortKey) {
    setSort(prev => {
      if (!prev || prev.key !== key) return {
        key,
        direction: 'asc'
      };
      if (prev.direction === 'asc') return {
        key,
        direction: 'desc'
      };
      return null;
    });
  }
  const visibleIds = [...state.outstandingGroups.flatMap(g => g.conditions), ...state.cleared].map(c => c.id);
  const allSelected = visibleIds.length > 0 && visibleIds.every(id => state.selectedIds.has(id));
  const someSelected = visibleIds.some(id => state.selectedIds.has(id));
  const sectionProps = {
    sort,
    selectedIds: state.selectedIds,
    onToggleSelect: state.toggleSelect,
    onUpdate: state.updateCondition,
    onComments: state.openComments,
    onUpload: state.uploadDocument,
    onLinkDocuments: state.openLinkDocuments
  };
  return <article className="rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-190" data-mp="2qzi4fkbugt6t">
      <div data-id="element-191" data-mp="1kkhepwdex78o">
        <ConditionsHeader conditions={state.conditions} attentionFilter={state.attentionFilter} onAttentionFilterChange={state.setAttentionFilter} selectedCount={state.selectedIds.size} onSendConditions={() => setSendOpen(true)} data-id="element-192" data-mp="1kkz9spoc9ff0" />

        <div role="table" aria-label="Conditions" data-id="element-193" data-mp="1m0bqrdrjq01a">
          <ConditionsTableHeader sort={sort} onSort={cycleSort} allSelected={allSelected} someSelected={someSelected} onToggleSelectAll={() => state.toggleSelectAll(visibleIds)} data-id="element-194" data-mp="1lz0m7bqa0o94" />
          {state.outstandingGroups.map(group => <ConditionSection key={group.id} title={group.label} conditions={group.conditions} emptyMessage={`No outstanding ${group.label.toLowerCase()} conditions.`} tone={groupTones[group.id]} {...sectionProps} data-id="element-195" data-mp="y9zczm9md92s" />)}
          <ConditionSection title="Cleared" conditions={state.cleared} emptyMessage="No cleared conditions yet." defaultOpen={false} showCategory tone={4} {...sectionProps} data-id="element-196" data-mp="fcels8jdtyf0" />
        </div>
      </div>

      <CommentsDrawer condition={state.commentCondition} events={state.commentEvents} onClose={state.closeComments} onSubmit={state.addComment} borrowerSendConfirmed={state.borrowerSendConfirmed} onBorrowerSendConfirmed={state.confirmBorrowerSend} data-id="element-197" data-mp="3rwsgl709m7n2" />
      <SendConditionsDialog open={sendOpen} conditions={state.conditions} onClose={() => setSendOpen(false)} onSend={state.sendConditions} data-id="element-198" data-mp="jok0nekomjo9" />
      <LinkDocumentsDialog condition={state.linkCondition} onClose={state.closeLinkDocuments} onLink={state.linkDocuments} data-id="element-199" data-mp="tewuxyiatr7l" />
    </article>;
}